/**
 * 캐릭터
 */
import { Fragment } from 'react';
import type { ICharacterAion, ISetCharacterAion, l10nType } from '@type/index';

const setCharacterAionItem = (item: ICharacterAion): ISetCharacterAion | null => {
  return item && typeof item === 'object'
    ? {
        ...item,
        url: `/characters/server/${item?.serverId}/id/${item?.characterId}/home`,
        legionUrl: `/legions/server/${item?.serverId}/id/${item?.legionId}/home`,
      }
    : null;
};

const setWearItemQualityToCode = (quality: string) => {
  const QualityMap = {
    common: 1,
    rare: 2,
    legend: 3,
    unique: 4,
    epic: 5,
    mythic: 6,
    ancient: 7,
    relic: 8,
    finality: 9,
  } as { [key: string]: number };

  return quality in QualityMap ? QualityMap[quality] : QualityMap['common'];
};

const CharacterAionArticle = ({ item, l10n }: { item: ICharacterAion; l10n: l10nType }) => {
  const data = setCharacterAionItem(item);

  if (!data) {
    return <Fragment />;
  }

  const { url, profileImageFullUrl, name, serverName, level, raceName, className, legionName, legionUrl, wearItem } = data;
  return (
    <div className="search-item-content">
      <div className="search-item-thumbnail">
        <a href={url}>
          <img src={profileImageFullUrl} alt="캐릭터프로필이미지" />
        </a>
      </div>
      <div className="search-item-article">
        <div className="search-item-title">
          <a href={url} dangerouslySetInnerHTML={{ __html: name }}></a>
        </div>
        <div className="search-item-info">
          <span>{serverName}</span>
          <span>Lv. {level}</span>
          <span>{raceName}</span>
          <span>{className}</span>
          {legionName ? (
            <span>
              <a href={legionUrl}>{legionName}</a>
            </span>
          ) : (
            <Fragment />
          )}
        </div>
        {wearItem ? (
          <div className="search-item-info">
            <span>
              착용장비 : <strong className={`quality_${setWearItemQualityToCode(wearItem?.quality)}`}>{wearItem?.name || ''}</strong>
            </span>
          </div>
        ) : (
          <Fragment />
        )}
      </div>
    </div>
  );
};

export default CharacterAionArticle;
